module.exports = "/_next/static/images/BadgeEurope@2x-84c9d4a9535c5155218e680a6856a2ee.png";